package com.schoolconnect.app.feature.students

import androidx.compose.runtime.Composable
import com.schoolconnect.app.feature.home.HomeFeatureRoute

@Composable
fun StudentsFeatureRoute(
    onBack: () -> Unit,
    homeRoleCode: String = "",
    homeSchoolLabel: String = "iConnect.School",
    onToggleTheme: () -> Unit = {},
    onLogout: () -> Unit = {},
    onHomeRoleChanged: (String, String, String) -> Unit = { _, _, _ -> }
) {
    HomeFeatureRoute(
        homeRoleCode = homeRoleCode,
        homeSchoolLabel = homeSchoolLabel,
        initialSelectedNavId = "students",
        onToggleTheme = onToggleTheme,
        onLogout = onLogout,
        onHomeRoleChanged = onHomeRoleChanged,
        onBack = onBack
    )
}
